// import React, { useEffect, useState } from 'react';
import Breadcrumbs from "../components/BreadcrumbsComponent";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";

interface Props {
  children: React.ReactNode;
}

const LayoutResults = ({ children }: Props) => {
    // const [showSearchBar, setShowSearchBar] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowSearchBar(true);
  //   }, 1000); // 5000ms = 5 seconds

  //   return () => clearTimeout(timer);
  // }, []);

  return (
     <div className="flex flex-col min-h-screen">
      <Header />
      {/* Apply min-h-screen to make this section take up at least the height of the viewport */}
     
        <Hero />
        <div className="pt-20 container mx-auto pt-2 z-30 px-8">
          <Breadcrumbs />
        </div>
        <div className="container mx-auto px-5 -mt-20">
          {/* {showSearchBar && <SearchBar />} */}
           <SearchBar country=''/>
        </div>
      
      <div className="container mx-auto py-10 flex-1">{children}</div>
      <Footer />
    </div>
  );
};
export default LayoutResults;
